// Generated automatically from Backend api_bookaro-lovepreet app/utls/constants.js
// Maps backend English message strings -> i18n keys (namespace "serverMessages").
// DO NOT EDIT BY HAND — regenerate via scripts/gen-server-messages.js

import i18n from "../i18n";

const MESSAGE_MAP = {
  "Login successfully.": "onBoarding.LOGIN_SUCCESS",
  "Current password is wrong": "onBoarding.CURRENT_PASSWORD",
  "Password changed successfully.": "onBoarding.PASSWORD_CHANGED",
  "Password is wrong!": "onBoarding.WRONG_PASSWORD",
  "Account is not active. Please contact to admin.": "onBoarding.USERNAME_INACTIVE",
  "Account is deleted. Please contact to admin": "onBoarding.USERNAME_DELETED",
  "Payload missing.": "onBoarding.PAYLOAD_MISSING",
  "Account not found.": "onBoarding.ACCOUNT_NOT_FOUND",
  "Document not found.": "onBoarding.DOCUMENT_NOT_FOUND",
  "Please check your email for otp.": "onBoarding.RESEND_VERIFICATION_CODE_SENT",
  "Verification code is incorrect.": "onBoarding.WRONG_VERIFICATION_CODE",
  "Please try again with resend email.": "onBoarding.LINK_EXPIRED",
  "Password reset successfully.": "onBoarding.PASSWORD_RESET",
  "Email already exist.": "onBoarding.EMAIL_EXIST",
  "New email already exist.": "onBoarding.NEW_EMAIL_EXIST",
  "Status changed successfully": "onBoarding.STATUS_CHANGED",
  "User deleted successfully.": "onBoarding.USER_DELETED",
  "Email required.": "onBoarding.EMAIL_REQUIRED",
  "User Id required": "onBoarding.USER_ID_REQUIRED",
  "Password required": "onBoarding.PASSWORD_REQUIRED",
  "Invalid credentials": "onBoarding.ONLY_USER_LOGIN",
  "Profile updated successfully.": "onBoarding.PROFILE_UPDATED",
  "Profile deleted successfully.": "onBoarding.PROFILE_DELETED",
  "User added successfully.": "onBoarding.USER_ADDED",
  "Document added successfully.": "onBoarding.DOC_ADDED",
  "This token will valid for 10 hours only.": "onBoarding.TOKEN_VALID",
  "Invalid id.": "onBoarding.INVALID_ID",
  "Please verify your email first.": "onBoarding.NOT_VERIFIED",
  "You can use this email.": "onBoarding.EMAIL_AVAILABLE",
  "Email is already in use.": "onBoarding.EMAIL_TAKEN",
  "OTP matched successfully": "onBoarding.OTP_MATCHED",
  "OTP not matched": "onBoarding.INVALID_OTP",
  "OTP sent successfully": "onBoarding.OTP_SENT",
  "Id required": "onBoarding.ID_REQUIRED",
  "Verification code required": "onBoarding.OTP_REQUIRED",
  "Two factor authentication enabled successfully.": "onBoarding.TWO_FACTOR_SUCCESS",
  "Login link sent to partner successfully.": "onBoarding.LOGIN_LINK_SENT",
  "User invited successfully.": "onBoarding.USER_INVITED",
  "User successfully registered": "onBoarding.SUCCESSFULLY_REGISTERED",
  "Please verify your email first": "onBoarding.USERNAME_VERIFIED",
  "No user exist with these credentials": "onBoarding.NO_USER_EXIST",
  "Address id invalid": "onBoarding.INVALID_ADDRESS",
  "User activated successfully": "onBoarding.USER_ACTIVATE",
  "You are not authorized user for this portal.": "onBoarding.NOT_VALID",
  "Invalid credentials.": "onBoarding.INVALID_CREDENTIAL",
  "666abbecdf0e68f5e9d28a99": "onBoarding.DUMMY_ID",
  "Email already exist in the application.": "onBoarding.ALREADY_EXITS",
  "Data not found": "onBoarding.DATA_NOT_FOUND",
  "Data retrieved successfully": "onBoarding.DATA_RETRIVED_SUCCESSFULLY",
  "Document already exist in the application.": "onBoarding.ALREADY_EXITS_DOC",
  "Document updated successfully.": "onBoarding.DOCUMENT_UPDATED",
  "Document activated successfully.": "onBoarding.DOCUMENT_ACTIVATED",
  "Document deactivated successfully.": "onBoarding.DOCUMENT_DEACTIVATED",
  "Document deleted successfully.": "onBoarding.DOCUMENT_DELETED",
  "User already exist": "onBoarding.USER_EXIST",
  "User logout successfully": "onBoarding.LOGOUT",
  "Group joined successfully": "USER.GROUP_JOINED",
  "Recents chat fetched successfully": "USER.RECENT_CHAT_FETCHED",
  "User ID is required": "USER.USER_ID_REQUIRED",
  "Unread count fetched successfully": "USER.UNREAD_COUNT_FETCHED",
  "User not found": "USER.NOT_FOUND",
  "Cannot delete venue it is associated with events": "USER.CANNOT_DELETE",
  "Staff added successfully": "STAFF.STAFF_ADDED",
  "Staff details fetched successfully": "STAFF.DETAILS",
  "Staff not exist": "STAFF.NOT_EXIST",
  "Agency added successfully": "AGENCY.AGENCY_ADDED",
  "Agency details fetched successfully": "AGENCY.DETAILS",
  "Agency not exist": "AGENCY.NOT_EXIST",
  "Agency not found": "AGENCY.NOT_FOUND",
  "Agency deleted successfully.": "AGENCY.AGENCY_DELETED",
  "Category already exist.": "category.ALREADY_EXIST",
  "Category created successfully.": "category.CREATED",
  "Category updated successfully.": "category.UPDATED",
  "Status changed successfully.": "category.STATUS_CHANGED",
  "Category deleted successfully.": "category.DELETED",
  "Unable to delete category as assocciated with features.": "category.ASSOCAITED_WITH_FEATURE",
  "Category order updated Successfully.": "category.ORDER_UPDATED",
  "Success": "COMMON.SUCCESS",
  "Invalid country code": "COMMON.INVALID_COUNTRY_CODE",
  "Something Went Wrong. Please try again.": "COMMON.SERVER_ERROR",
  "You are not authorized to perform this operation": "COMMON.UNAUTHORIZED",
  "Status Change Successfully": "COMMON.STATUS_CHANGED",
  "Invalid File Type": "COMMON.NOT_VALID_FILE",
  "Invalid Id": "COMMON.INVALID_ID",
  "You are using unsupported version of API": "COMMON.UNSUPPORTED_API_VERSION",
  "This API no longer exists": "COMMON.API_NOT_EXIST",
  "Invalid coordinates": "COMMON.INVALID_COORDINATES",
  "Smtp not found": "COMMON.SMTP_NOT_FOUND",
  "Model name required": "COMMON.MODEL_NAME_REQUIRED",
  "Unprocessable data": "COMMON.UNPROCESSABLE_DATA",
  "Payload  missing.": "COMMON.PAYLOAD_MISSING",
  "Roles already exist.": "roles.ALREADY_EXIST",
  "Roles created successfully.": "roles.CREATED",
  "Id required.": "roles.ID_MISSING",
  "Roles updated successfully.": "roles.UPDATED",
  "Roles deleted successfully.": "roles.DELETED",
  "Service already exist.": "Services.ALREADY_EXIST",
  "Service created successfully.": "Services.CREATED",
  "Service updated successfully.": "Services.UPDATED",
  "Service deleted successfully.": "Services.DELETED",
  "Plan already exist.": "PLAN.ALREADY_EXIST",
  "Plan created successfully.": "PLAN.CREATED",
  "Plan updated successfully.": "PLAN.UPDATED",
  "Plan deleted successfully.": "PLAN.DELETED",
  "Plan not found.": "PLAN.NOT_FOUND",
  "Category not found.": "CATEGORY.NOT_FOUND",
  "Cannot delete this category it is associated with events.": "CATEGORY.CANNOT_DELETE",
  "Category type already exist.": "CATEGORYTYPE.ALREADY_EXIST",
  "Category type created successfully.": "CATEGORYTYPE.CREATED",
  "Category type updated successfully.": "CATEGORYTYPE.UPDATED",
  "Category type deleted successfully.": "CATEGORYTYPE.DELETED",
  "Unable to delete category type as assocciated with features.": "CATEGORYTYPE.ASSOCAITED_WITH_FEATURE",
  "Category type not found.": "CATEGORYTYPE.NOT_FOUND",
  "Cannot delete this category type it is associated with category.": "CATEGORYTYPE.CANNOT_DELETE",
  "Payload missing": "AMENITIES.PAYLOAD_MISSING",
  "Amenity already exist.": "AMENITIES.ALREADY_EXIST",
  "Amenity created successfully.": "AMENITIES.CREATED",
  "Amenity updated successfully.": "AMENITIES.UPDATED",
  "Amenity deleted successfully.": "AMENITIES.DELETED",
  "Amenity not found.": "AMENITIES.NOT_FOUND",
  "Feature already exist.": "FEATURE.ALREADY_EXIST",
  "Feature created successfully.": "FEATURE.CREATED",
  "Feature updated successfully.": "FEATURE.UPDATED",
  "Feature deleted successfully.": "FEATURE.DELETED",
  "Feature not found.": "FEATURE.NOT_FOUND",
  "Feature retrieved successfully": "FEATURE.RETRIEVED",
  "Error in creating feature": "FEATURE.ERROR_IN_CREATING",
  "BLOG already exist.": "BLOG.ALREADY_EXIST",
  "BLOG created successfully.": "BLOG.CREATED",
  "BLOG updated successfully.": "BLOG.UPDATED",
  "Blogs retrieved successfully.": "BLOG.RETRIEVED",
  "Blogs not found.": "BLOG.NOT_FOUND",
  "Title already exist.": "BLOG.TITLE_EXIST",
  "Blog deleted successfully.": "BLOG.DELETED",
  "Data already exist.": "FOLLOW_UNFOLLOW.ALREADY_EXIST",
  "Data created successfully.": "FOLLOW_UNFOLLOW.CREATED",
  "Data updated successfully.": "FOLLOW_UNFOLLOW.UPDATED",
  "Data retrieved successfully.": "FOLLOW_UNFOLLOW.RETRIEVED",
  "Data not found.": "FOLLOW_UNFOLLOW.NOT_FOUND",
  "Data deleted successfully.": "FOLLOW_UNFOLLOW.DELETED",
  "Budget already exist.": "BUDGET.ALREADY_EXIST",
  "Budget created successfully.": "BUDGET.CREATED",
  "Budget updated successfully.": "BUDGET.UPDATED",
  "Budget retrieved successfully.": "BUDGET.RETRIEVED",
  "Budget not found.": "BUDGET.NOT_FOUND",
  "Budget deleted successfully.": "BUDGET.DELETED",
  "FAQ created successfully.": "FAQ.CREATED",
  "FAQ updated successfully.": "FAQ.UPDATED",
  "FAQ retrieved successfully.": "FAQ.RETRIEVED",
  "FAQ not found.": "FAQ.NOT_FOUND",
  "Question already exist.": "FAQ.QUESTION_EXIST",
  "FAQ deleted successfully.": "FAQ.DELETED",
  "Content already exist.": "CONTENT_MANAGEMENT.ALREADY_EXIST",
  "Content created successfully.": "CONTENT_MANAGEMENT.CREATED",
  "Content updated successfully.": "CONTENT_MANAGEMENT.UPDATED",
  "Content deleted successfully.": "CONTENT_MANAGEMENT.DELETED",
  "Content found successfully": "CONTENT_MANAGEMENT.FOUND_SUCCESS",
  "Property added successfully": "PROPERTY.CREATED",
  "Listing retrieved successfully": "PROPERTY.RETRIEVED",
  "Property not found.": "PROPERTY.NOT_FOUND",
  "Property deleted successfully.": "PROPERTY.DELETED",
  "Property updated successfully.": "PROPERTY.UPDATED",
  "Property featured successfully": "PROPERTY.FEATURED",
  "Property unfeatured successfully": "PROPERTY.UNFEATURED",
  "Property like successfully": "PROPERTY.LIKED",
  "Property unlike successfully": "PROPERTY.UN_LIKED",
  "Property follow successfully": "PROPERTY.FOLLOW",
  "Property unfollow successfully": "PROPERTY.UNFOLLOW",
  "Invalid User ID": "CARD.INVALID_USER_ID",
  "Unable to create stripe customer": "CARD.UNABLE_TO_CREATE_STRIPE_CUSTOMER",
  "Unable to create customer source": "CARD.UNABLE_TO_CREATE_CUSTOMER_SOURCE",
  "Card added successfully": "CARD.ADDED",
  "Card fetched successfully": "CARD.FETCHED",
  "Cards fetched successfully": "CARD.FETCHED_ALL",
  "Id is required": "CARD.ID_REQUIRED",
  "Can't delete primary card": "CARD.CANT_DELETE_PRIMARY_CARD",
  "Card removed successfully": "CARD.DELETED",
  "Invalid id": "CARD.INVALID_ID",
  "User is not authorized": "CARD.UNAUTHORIZED",
  "Card set as primary card successfully": "CARD.PRIMARY_SET",
  "Card already exists": "CARD.CARD_EXIST",
  "Unable to create customer": "CARD.UNABLE_TO_CREATE_BRAINTREE_CUSTOMER",
  "Property saved in drafts.": "DRAFTPROPERTY.CREATED",
  "Property removed from drafts.": "DRAFTPROPERTY.DELTED",
  "User drafts fetched.": "DRAFTPROPERTY.DATA_FETCH",
  "Cannot save this as draft.": "DRAFTPROPERTY.CANNOTSAVE",
  "Draft not found.": "DRAFTPROPERTY.NOT_FOUND",
  "School with these specification already exists.": "SCHOOL.EXISTS",
  "New school successfully added.": "SCHOOL.ADDED",
  "School deleted successfully.": "SCHOOL.DELETED",
  "Id is required.": "SCHOOL.ID_REQ",
  "School either doesn't exists or has been deleted.": "SCHOOL.NOT_EXISTS"
};

// Translate a raw backend message into the current i18n language.
// Use the global i18n instance so callers don't need a t in scope.
export const translateServerMessage = (message) => {
  if (!message || typeof message !== "string") return message;
  const key = MESSAGE_MAP[message];
  if (!key) return message;
  return i18n.t(key, { ns: "serverMessages", defaultValue: message });
};

export default translateServerMessage;
